import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { RouterProvider } from "react-router";

import { ThemeProvider } from "@mui/material";

import AuthWrapper from "./auth/AuthWrapper.tsx";
import { theme } from "./contexts/Mui.ts";
import "./index.css";
import { router } from "./routes.tsx";

const cognitoAuthConfig = {
  authority: import.meta.env.VITE_COGNITO_AUTHORITY,
  client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_COGNITO_REDIRECT_URI,
  response_type: "code",
  scope: "openid email profile",
};

const rootContainer = document.getElementById("root");
const root = createRoot(rootContainer!);

root.render(
  <StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <AuthWrapper>
        <ThemeProvider theme={theme}>
          <RouterProvider router={router} />
        </ThemeProvider>
      </AuthWrapper>
    </AuthProvider>
  </StrictMode>
);
